import styled from "styled-components";

export const PlanSection = styled.div`
  position: relative;
  z-index: 1;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.colorsNew.gray[100]};
`;

export const PlanSectionInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0 16px;
  background-color: ${({ theme }) => theme.colors.colorsNew.base.white};
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.colors.colorsNew.gray[200]};
  position: relative;
  z-index: 3;
`;

export const PricingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 10px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.colorsNew.gray[200]};
  gap: ${({ theme }) => theme.margin.m16};
`;

export const PricingBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 50%;
`;

export const Price = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
